export default {
    absoluteTimeoutPrompt: 15, // time in minutes to show absolute timeout dialog before timeout // TODO: tokenize
    applicationId: 1,
    idlePrompt: 5, // time in minutes to show idle dialog before timeout // TODO: tokenize
    notificationRefresh: 60, // time in seconds to check for new notifications
    sessionRefresh: 60, // time in seconds to ping to refresh session // TODO: tokenize
    tokenRefresh: 15 // time in minutes to ping server for a fresh token before expiration
};